import assessmentTestRoutes from "./assessmentTestRoutes"

const routes = [
    {
        path: "/sat",
        name: "sat.index",
        component: () => import("../SAT/index.vue"),
        meta: { is_protected: true },
        children: [...assessmentTestRoutes({ isSAT: true })],
    },
]

export default routes
